import { Button, Paper } from '@mui/material'
import { COLUMNS_NAME } from 'Components/Constants/ColumnsNames'
import { currency } from 'Components/MUI_components/currencyFormatterTag'
import Reports from 'Components/Print/a4-report-print'
import React from 'react'
import { DownloadTableExcel } from 'react-export-table-to-excel'
import ReactToPrint from 'react-to-print'
import { pageStyle } from "Components/Print/printPagesStyles";

const PreviewTable = (props) => {
const  {
    tableRef,
    componentRef,
    value

} = props
    const DebitTotal = value.map((row) => row.entryType == 0 ? parseFloat(row.amount) : 0)
    .reduce((sum, i) => sum + i, 0);

    const creditTotal = value.map((row) => row.entryType == 1 ? parseFloat(row.amount) : 0)
    .reduce((sum, i) => sum + i, 0);
    return (
        <div >
            {value.length > 0 && (
                <Paper style={{ padding: "10px" }}>
                    <div className="flex-end">
                        <ReactToPrint
                            trigger={() => (
                                <Button
                                    style={{ margin: 5 }}

                                    variant="contained"
                                >
                                    Print
                                </Button>
                            )}
                            content={() => componentRef.current}
                            pageStyle={pageStyle.a4}
                        />
                        <DownloadTableExcel
                            filename="Day End"
                            currentTableRef={tableRef.current}
                        >
                            <Button
                                style={{ margin: 5 }}

                                variant="contained"
                            >
                                Export to Excel </Button>
                        </DownloadTableExcel>

                    </div>
                    <div className="justify-content-center"
                        ref={componentRef}>
                        <Reports
                            title={
                                "Preview Transactions"
                            }

                        >
                            <table
                                className="print-table mt "
                                aria-label="customized table"
                                ref={tableRef}>
                                <thead className="thead" style={{ borderBottom: "1px solid #24242450" }}>
                                    <tr style={{ backgroundColor: "#cacaca" }}>
                                        <th align="left">{COLUMNS_NAME.TRANSACTION_TYPE}</th>
                                        <th align="left">{COLUMNS_NAME.LEDGER_TYPE}</th>
                                        {/* <th align="left" >{COLUMNS_NAME.ENTRY_TYPE}</th> */}
                                        <th align="left">{COLUMNS_NAME.TRANSACTION_MODE}</th>
                                        <th align="right">{COLUMNS_NAME.DEBIT}</th>
                                        <th align="right">{COLUMNS_NAME.CREDIT}</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <>
                                        {value.map((row, index) => (
                                            <>
                                            {row.amount ==  "0.00" || 0 ? ("") : (
                                                <tr key={index}>
                                                <td align="left">
                                                    {
                                                        row.sourceCode == 21 ? "Brought Forward Amount" : "" ||
                                                        row.sourceCode == 21 ? "Brought Forward Amount" : "" ||
                                                        row.sourceCode == 22 ? "Brought Forward Amount" : "" ||
                                                        row.sourceCode == 22 ? "Brought Forward Amount" : "" ||
                                                        row.sourceCode == 23 ? "Brought Forward Amount" : "" ||
                                                        row.sourceCode == 23 ? "Brought Forward Amount" : "" ||
                                                        row.sourceCode == 1 ? "Payment Receipt Total" : "" ||
                                                        row.sourceCode == 2 ? "Cash Payment" : "" ||
                                                        row.sourceCode == 3 ? "Cheque Payment" : "" ||
                                                        row.sourceCode == 4 ? "Card Payment  " : "" ||
                                                        row.sourceCode == 5 ? "Bank Payment" : "" ||
                                                        row.sourceCode == 6 ? "Return Amount" : "" ||
                                                        row.sourceCode == 7 ? "Over Payment" : "" ||
                                                        row.sourceCode == 8 ? "Expenses" : "" ||
                                                        row.sourceCode == 9 ? "Payment Voucher Total" : "" ||
                                                        row.sourceCode == 10 ? "Supplier Cash Payment" : "" ||
                                                        row.sourceCode == 11 ? "Supplier Cheque Payment" : "" ||
                                                        row.sourceCode == 12 ? "Supplier Card Payment" : "" ||
                                                        row.sourceCode == 13 ? "Supplier BankPayment" : "" ||
                                                        row.sourceCode == 14 ? "Purchase Return" : "" ||
                                                        row.sourceCode == 15 ? "Sales Return" : "" ||
                                                        row.sourceCode == 17 ? "Customer Cheque Return Cash Payment" : "" ||
                                                        row.sourceCode == 18 ? "Customer Cheque Return Cheque Payment" : "" ||
                                                        row.sourceCode == 19 ? "Customer Cheque Return Bank Payment" : "" ||
                                                        row.sourceCode == 20 ? "Customer Cheque Return Card Payment" : "" ||
                                                        row.sourceCode == 24 ? "Online Transfer Payment" : "" ||
                                                        row.sourceCode == 25 ? "Supplier Online Transfer Payment" : "" ||
                                                        row.sourceCode == 26 ? "Customer Cheque Return Return Online payment" : "" ||
                                                        row.sourceCode == 27 ? "Expense Cash payment" : "" ||
                                                        row.sourceCode == 28 ? "Expense  Cheque payment" : "" ||
                                                        row.sourceCode == 29 ? "Expense Card  payment" : "" ||
                                                        row.sourceCode == 30 ? "Expense Bank payment" : "" ||
                                                        row.sourceCode == 31 ? "Expense Online payment" : "" ||
                                                        row.transactionTypeName ? row.transactionTypeName : ""}
                                                </td>
                                                <td align="left">
                                                    {row.ledgerType == 4601000001 ? "CASH BOOK" : "" ||
                                                     row.ledgerType == 4601000002 ? "BANK " : "" ||
                                                     row.ledgerType == 4601000003 ? "CREDIT CARD" : "" ||
                                                     row.ledgerType == 4601000004 ? "CAPITAL_ACCOUNT_PLR" : "" ||
                                                     row.ledgerType == 4601000005 ? "RICELAND_PVT_LTD" : "" || 
                                                     row.ledgerType == 4601000006 ? "CA_MR_RAFEEK" : ""
                                                     }
                                                </td>
                                                <td align="left">{row.transactionType == 0 ? " CASH" : "CHEQUE"}</td>
                                                {row.amount < 0 ? (
                                                    <>
                                                        <td align="right"> {row.entryType == 0 ? `(${currency(row.amount)})`  : "-"}</td>
                                                        <td align="right">{row.entryType == 0 ? "-" : `(${currency(row.amount)})`  }</td>
                                                    </>
                                                   
                                                ):(
                                                    <>
                                                        <td align="right">{row.entryType == 0 ? currency(row.amount)  : "-"}</td>
                                                        <td align="right">{row.entryType == 0 ? "-" : currency(row.amount) }</td>
                                                    </>
                                              
                                                )}
                                                
                                            </tr>
                                            )}
                                                
                                            </>
                                        ))}
                                        <tr>
                                            <td colSpan={3}></td>
                                            <td align="right"><strong>{DebitTotal<0 ? `(${ currency(DebitTotal)})` : currency(DebitTotal)}</strong> </td>
                                            <td align="right"><strong>{creditTotal<0 ? `(${ currency(creditTotal)})` : currency(creditTotal) }</strong> </td>
                                        </tr>

                                    </>
                                </tbody>
                            </table>

                        </Reports>

                    </div>
                    <div className="mb-3 row flex-end" >

                    </div>


                </Paper>
            )}

        </div>
    )
}

export default PreviewTable